<template>
<div>
  <div class="horizontal">
    <div class="left">{{ item.heading }}</div>
    <div class="right">
      <div class="keireki">
        <div class="keireki-item"
          v-for="(history, index) in item.data.histories">
          <div class="date">
            {{ $planConfig.dateIntFormat(history.date) }}
            <template v-if="history.termDate.year">
              &nbsp;~&nbsp;{{ $planConfig.dateIntFormat(history.termDate) }}
            </template>
          </div>
          <div class="text">{{ history.desc }}</div>
        </div>
      </div>
    </div>
  </div>
  <expert-comment v-bind:item="item"
    v-if="isConsultationPlan"
    v-bind:groupIndex="groupIndex"
    v-bind:itemIndex="itemIndex"
    v-bind:isEditableComment="isEditableComment"></expert-comment>
</div>
</template>

<script>
import expertComment from '@/components/parts/ExpertComment'
export default {
  components: {
    'expert-comment': expertComment
  },
  data() {
    return {}
  },
  props: ['item', 'groupIndex', 'itemIndex', 'isConsultationPlan', 'isEditableComment'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
